export const ORG_DIVISIONS = [
  { key: 'finance', label: 'Finance' },
  { key: 'accounting', label: 'Accounting' },
  { key: 'sales', label: 'Sales' },
  { key: 'marketing', label: 'Marketing' },
  { key: 'operasional', label: 'Operasional' },
  { key: 'hr', label: 'HR' },
  { key: 'legal', label: 'Legal' },
  { key: 'rnd', label: 'RnD' },
  { key: 'produksi', label: 'Produksi' },
  { key: 'supply_chain', label: 'Supply Chain' },
  { key: 'it', label: 'IT' },
] as const;

export const ORG_LEVELS = [
  { key: 'director', label: 'Direktur' },
  { key: 'general_manager', label: 'General Manager' },
  { key: 'manager', label: 'Manager' },
  { key: 'supervisor', label: 'Supervisor' },
  { key: 'coordinator', label: 'Koordinator' },
  { key: 'staff', label: 'Staff' },
] as const;

export type OrgDivisionKey = (typeof ORG_DIVISIONS)[number]['key'];
export type OrgLevelKey = (typeof ORG_LEVELS)[number]['key'];

export const ORG_DIVISION_KEY_SET = new Set<string>(ORG_DIVISIONS.map(item => item.key));
export const ORG_LEVEL_KEY_SET = new Set<string>(ORG_LEVELS.map(item => item.key));

/** Returns 0-based index of a level key, or -1 if not found. */
export const getLevelIndex = (levelKey?: string | null): number => {
  if (!levelKey) return -1;
  return ORG_LEVELS.findIndex(l => l.key === levelKey);
};

/** Returns the next level key one step below the given one, or null at the last level. */
export const getNextLevelKey = (levelKey?: string | null): OrgLevelKey | null => {
  const idx = getLevelIndex(levelKey);
  if (idx < 0 || idx >= ORG_LEVELS.length - 1) return null;
  return ORG_LEVELS[idx + 1].key;
};
